var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplication.jinja"] = require( "front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplication.jinja" );
dependencies["front/components/ProductionDesignInitiativeApplicationCancel/ProductionDesignInitiativeApplicationCancel.jinja"] = require( "front/components/ProductionDesignInitiativeApplicationCancel/ProductionDesignInitiativeApplicationCancel.jinja" );
dependencies["front/components/ProductionDesignInitiativeApplicationAgreement/ProductionDesignInitiativeApplicationAgreement.jinja"] = require( "front/components/ProductionDesignInitiativeApplicationAgreement/ProductionDesignInitiativeApplicationAgreement.jinja" );
dependencies["front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja"] = require( "front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplication.jinja", false, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "ProductionDesignInitiativeApplication")) {
var t_10 = t_7.ProductionDesignInitiativeApplication;
} else {
cb(new Error("cannot import 'ProductionDesignInitiativeApplication'")); return;
}
context.setVariable("ProductionDesignInitiativeApplication", t_10);
output += "\n\n";
env.getTemplate("front/components/ProductionDesignInitiativeApplicationCancel/ProductionDesignInitiativeApplicationCancel.jinja", false, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "ProductionDesignInitiativeApplicationCancel")) {
var t_14 = t_11.ProductionDesignInitiativeApplicationCancel;
} else {
cb(new Error("cannot import 'ProductionDesignInitiativeApplicationCancel'")); return;
}
context.setVariable("ProductionDesignInitiativeApplicationCancel", t_14);
output += "\n\n";
env.getTemplate("front/components/ProductionDesignInitiativeApplicationAgreement/ProductionDesignInitiativeApplicationAgreement.jinja", false, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
t_15.getExported(function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
if(Object.prototype.hasOwnProperty.call(t_15, "ProductionDesignInitiativeApplicationAgreement")) {
var t_18 = t_15.ProductionDesignInitiativeApplicationAgreement;
} else {
cb(new Error("cannot import 'ProductionDesignInitiativeApplicationAgreement'")); return;
}
context.setVariable("ProductionDesignInitiativeApplicationAgreement", t_18);
output += "\n\n";
env.getTemplate("front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja", false, "assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja", false, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
t_19.getExported(function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
if(Object.prototype.hasOwnProperty.call(t_19, "ProductionDesignInitiativeApplicationSuccess")) {
var t_22 = t_19.ProductionDesignInitiativeApplicationSuccess;
} else {
cb(new Error("cannot import 'ProductionDesignInitiativeApplicationSuccess'")); return;
}
context.setVariable("ProductionDesignInitiativeApplicationSuccess", t_22);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
output += t_23;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"GuildProductionDesignInitiativePopup\" data-state=\"application\">\n\n        <div class=\"GuildProductionDesignInitiativePopup-header\">\n            <div class=\"GuildProductionDesignInitiativePopup-header-title\"><a href=\"";
output += runtime.suppressValue((lineno = 15, colno = 87, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_production_design_initiative"])), env.opts.autoescape);
output += "\">Production Design Initiative</a></div>\n            <div class=\"GuildProductionDesignInitiativePopup-header-caption\">Application</div>\n            <div class=\"GuildProductionDesignInitiativePopup-header-footer\">\n                <div class=\"GuildProductionDesignInitiativePopup-header-deadline\"><span>DEADLINE:</span> ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline")),"date")) {
output += runtime.suppressValue(env.getFilter("datetimeNoZeroPadding").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"deadline")),"date"),"%B %d, %Y AT %I%p PST"), env.opts.autoescape);
;
}
else {
output += "TBD";
;
}
output += "</div>\n                <div class=\"GuildProductionDesignInitiativePopup-header-note\">* PLEASE ENTER ALL REQUIRED FIELDS AND INCLUDE THE $";
output += runtime.suppressValue(env.getFilter("int").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"price")), env.opts.autoescape);
output += " APPLICATION FEE.</div>\n            </div>\n        </div>\n\n        <div class=\"GuildProductionDesignInitiativePopup-content\">\n            <div class=\"GuildProductionDesignInitiativePopup-application\">\n                ";
output += runtime.suppressValue((lineno = 25, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ProductionDesignInitiativeApplication"), "ProductionDesignInitiativeApplication", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "popup")})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"GuildProductionDesignInitiativePopup-review\">\n            </div>\n        </div>\n\n\n        <div class=\"GuildProductionDesignInitiativePopup-buttons\">\n            <div class=\"GuildProductionDesignInitiativePopup-buttonsWrapper\">\n                <div class=\"GuildProductionDesignInitiativePopup-buttonsCancel\">Cancel</div>\n                <div class=\"GuildProductionDesignInitiativePopup-buttonsBack\">Back</div>\n\n                <div class=\"GuildProductionDesignInitiativePopup-buttonsReview\">Review & Continue</div>\n                <div class=\"GuildProductionDesignInitiativePopup-buttonsSubmit\">Submit</div>\n            </div>\n        </div>\n\n        <div class=\"GuildProductionDesignInitiativePopup-mobileMessage\">\n            <div class=\"GuildProductionDesignInitiativePopup-mobileMessageTitle\">Applying for<br> the PD Initiative<br> is not supported<br> for mobile</div>\n            <div class=\"GuildProductionDesignInitiativePopup-mobileMessageText\">Please go to your desktop or laptop computer to continue.</div>\n        </div>\n\n        ";
output += runtime.suppressValue((lineno = 47, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ProductionDesignInitiativeApplicationCancel"), "ProductionDesignInitiativeApplicationCancel", context, [])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 49, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ProductionDesignInitiativeApplicationAgreement"), "ProductionDesignInitiativeApplicationAgreement", context, [runtime.makeKeywordArgs({"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"agreementRendered")})])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 51, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ProductionDesignInitiativeApplicationSuccess"), "ProductionDesignInitiativeApplicationSuccess", context, [])), env.opts.autoescape);
output += "\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.jinja
// module id = 534
// module chunks = 0